import { useIntl as _useIntl } from '@umijs/max';
import React from 'react';

export type TUseIntl = (id: string | undefined | null | React.ReactNode, firstArg?: string, secondArg?: string) => string;

const useIntl = () => {
    const { formatMessage } = _useIntl();

    const t: TUseIntl = (id, firstArg = '', secondArg = '') => {
        if (!id) return '';
        return formatMessage(
            // @ts-ignore
            { id },
            { firstArg, secondArg }
        );
    };

    return t;
};

export default useIntl;
